<div class="container-fluid full-width d-flex flex-column overflow-hidden h-100vh" *ngIf='channels'
     dpadScrollableVertical>
    <h2 *ngIf="header" class="page-title">{{header}}</h2>

    <div class="hero-container-ar" *ngIf="type !== 'shows'" dpadZone="hero">
        <app-hero-image-slider *ngIf="heroResponse" [heroes]="heroResponse?.heroes" (focused)="focusedRow = -1"></app-hero-image-slider>
        <div *ngIf="!heroResponse" class="hero-placeholder"></div>
    </div>

    <div class="padding-bot-main" dpadZone="sliders">
        <div *ngFor="let channel of channels; let i = index" [style.z-index]="100 - i" class="position-relative">
            <div class="flex-column" *ngIf="((channel.media != null && channel.media.length > 0)
            || (channel.itemIds != null && channel.itemIds.length > 0)
            || (channel.items != null && channel.items.length > 0)
            || (channel.creatorTeams && channel.creatorTeams.length > 0)
            || (channel.type == 'user-recommendations' && isAuthenticated())
            || (channel.type.startsWith('playlist') && isAuthenticated())
            || (channel.type == 'continue-watching' && isAuthenticated()))
            && channel.type !== 'latest-player'">

                <app-channel-header [channel]="channel" [showBadge]="channel.type !== 'media-list-channel'"
                                    *ngIf="channel.type !== 'season-banner' && (channel.type !== 'season-banner' && channel.type !== 'continue-watching')">
                </app-channel-header>

                <app-image-slider-smart-tv
                        *ngIf="(channel.type == 'media-list' || channel.type === 'media-list-channel' || channel.type === 'hot-list' || channel.type === 'user-recommendations' || channel.type === 'creator-row') && !channel.itemType && channel.media?.length > 0" [isShowsPage]="type === 'shows'" [rowIndex]="i" [rowFocusIndex]="focusedRow"
                        [type]="channel.type" [thumbnailType]="channel.thumbnailType" [items]="channel.media" [currentFocus]="focusedRow === i" (rowFocused)="rowFocused(i)" [recommendationId]="channel.recommendationId">
                </app-image-slider-smart-tv>

                <app-image-slider-smart-tv *ngIf="channel.itemType" [type]="channel.type" [items]="channel.items" [isShowsPage]="type === 'shows'" [rowIndex]="i" [rowFocusIndex]="focusedRow"
                                           [currentFocus]="focusedRow === i" (rowFocused)="rowFocused(i)">
                </app-image-slider-smart-tv>

                <app-image-slider-smart-tv *ngIf="channel.type === 'creator-list'" [items]="channel.creatorTeams" [type]="channel.type" [thumbnailType]="channel.thumbnailType" [currentFocus]="focusedRow === i" (rowFocused)="rowFocused(i)">>
                </app-image-slider-smart-tv>

                <app-season-banner *ngIf="channel.type == 'season-banner' && channel.media" [channel]="channel"
                                   [currentFocus]="focusedRow === i" (rowFocused)="rowFocused(i)">
                </app-season-banner>
                <app-continue-watching *ngIf="channel.type == 'continue-watching'"
                                       [currentFocus]="focusedRow === i" (rowFocused)="rowFocused(i)"></app-continue-watching>
            </div>
        </div>
    </div>
</div>
